module.exports = __webpack_public_path__ + "media/images/healthy-f7020f446a3492216f6a320a00190296.png";